/**
 * plugins/vuetifyOptions.ts
 *
 * Vuetify configuration shared by the application and the test harness.
 *
 * Kept separate from `plugins/vuetify.ts` because that module also imports
 * the Vuetify SCSS and the MDI font, which tests neither need nor should
 * pay for. Sharing the options is what stops the test environment from
 * silently rendering Vuetify's own strings in English while the app renders
 * them in Vietnamese.
 */
// Narrow subpath rather than the `vuetify/labs/components` barrel, which
// pulls in every labs component and dominated test setup time.
import { VDateInput } from "vuetify/labs/VDateInput";
import { vi } from "vuetify/locale";

export const vuetifyOptions = {
  components: {
    VDateInput,
  },
  locale: {
    locale: "vi",
    messages: {
      vi: {
        ...vi,
        close: "Đóng",
      },
    },
  },
  theme: {
    defaultTheme: "light",
  },
};
